import type { PlaceholderBucket } from "./uploadedConversationsVisualizerPlaceholderLenses"

export interface SetSlice {
  bucket: PlaceholderBucket
  endAngle: number
  span: number
  startAngle: number
}

const SETS_ANGLE_START_RADIANS = -Math.PI / 2

export function buildSetRegionSlices(buckets: PlaceholderBucket[]): SetSlice[] {
  if (buckets.length === 0) {
    return []
  }
  const normalizedCounts = buckets.map((bucket) => Math.max(0, bucket.count))
  const totalCount = normalizedCounts.reduce((sum, count) => sum + count, 0)
  const fallbackShare = 1 / buckets.length
  let consumedAngle = 0

  return buckets.map((bucket, bucketIndex) => {
    const share =
      totalCount > 0
        ? normalizedCounts[bucketIndex] / totalCount
        : fallbackShare
    const startAngle = SETS_ANGLE_START_RADIANS + consumedAngle
    const remainingAngle = Math.max(0, Math.PI * 2 - consumedAngle)
    const span =
      bucketIndex === buckets.length - 1
        ? remainingAngle
        : Math.min(remainingAngle, Math.max(0, share * Math.PI * 2))
    const endAngle = startAngle + span
    consumedAngle += span

    return {
      bucket,
      endAngle,
      span,
      startAngle,
    }
  })
}
